import React from "react";
import { Checkbox } from "components/Graphs/Checkbox";

export const NGC_API_KEY_CREATION_ERROR_MESSAGE =
  "We could not create an API key. Create the agent and follow instructions to create it manually.";

export type NgcApiKeyDeployResult = {
  ngcApiKeySpecFailed?: boolean;
};

interface NgcApiKeyOptionProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  errorMessage?: string | null;
  disabled?: boolean;
  isAiPlaygroundsKey: boolean;
}

export const NgcApiKeyOption: React.FC<NgcApiKeyOptionProps> = ({
  checked,
  onCheckedChange,
  errorMessage,
  disabled,
  isAiPlaygroundsKey,
}) => {
  const errorId = "ngc-api-key-option-error";
  const descriptionId = "ngc-api-key-option-description";

  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id="create-ngc-api-key"
        className="mt-0.5"
        checked={checked}
        disabled={disabled}
        aria-describedby={errorMessage ? errorId : descriptionId}
        onCheckedChange={(nextChecked) => onCheckedChange(nextChecked === true)}
      />
      <div className="flex flex-col gap-1">
        <label
          htmlFor="create-ngc-api-key"
          className="text-sm font-medium leading-snug text-primary cursor-pointer"
        >
          Generate NVIDIA API key
        </label>
        {errorMessage ? (
          <p id={errorId} className="text-xs leading-snug text-red-400">
            {errorMessage}
          </p>
        ) : isAiPlaygroundsKey ? (
          <p id={descriptionId} className="text-xs leading-snug text-secondary">
            Get access to inference endpoints for models hosted at{" "}
            <a
              href="https://build.nvidia.com/models"
              target="_blank"
              rel="noreferrer"
              className="underline text-highlight"
            >
              build.nvidia.com
            </a>
            .
          </p>
        ) : (
          <p id={descriptionId} className="text-xs leading-snug text-secondary">
            Create an NGC API key for this launchable.
          </p>
        )}
      </div>
    </div>
  );
};
